import { ConfigService } from '@axo/config/ConfigService';
import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useFormContext } from 'react-hook-form';
import { useAxoFormContext } from '../../../../../../context/AxoForm/AxoForm';
import { useBroker } from '../../../../../../hooks/useBroker';
import { formatSpacedNumber } from '../../../../../../utils/format';
import { RefinanceDebtFormGroupData } from '../../../../FormData.fi.types';
import { gridColumns } from '../../../config/layouts/grid';
import styles from '../../../loan.module.scss';
import {
  debtCreditCardMonthlyDebtPaymentFieldOption,
  debtCreditCardOutstandingAmountFieldOption,
  debtPersonalMonthlyDebtPaymentFieldOption,
  debtPersonalOutstandingAmountFieldOption,
} from './config';

export const RefinanceDebtFormGroup = () => {
  const { t } = useTranslation();

  const broker = useBroker();
  const { hasCreditCardMonthlyDebtPayment } = ConfigService.get(
    'product-unsecured-loan'
  ).fields[broker];

  const { watch } = useFormContext();

  const { axoFormData } = useAxoFormContext();

  const maritalStatus = axoFormData['LoanApplication/MaritalStatus'];

  const [creditCardDebt, personalDebt] = watch([
    'Debt/CreditCard/OutstandingAmount',
    'Debt/Personal/OutstandingAmount',
  ]);

  const askCreditCardDebtMonthlyPayment =
    hasCreditCardMonthlyDebtPayment && Number(creditCardDebt) > 0;
  const askPersonalDebtMonthlyPayment = Number(personalDebt) > 0;

  return (
    <>
      <Grid columns={gridColumns}>
        <NumberFieldUI<RefinanceDebtFormGroupData>
          name="Debt/CreditCard/OutstandingAmount"
          label={t('Debt.CreditCard.OutstandingAmount.label')}
          data-testid="debt-credit-card-outstanding-amount-input"
          format={formatSpacedNumber}
          suffix={t('suffix.currency')}
          {...debtCreditCardOutstandingAmountFieldOption}
        />

        {askCreditCardDebtMonthlyPayment && (
          <NumberFieldUI<RefinanceDebtFormGroupData>
            name="Debt/CreditCard/MonthlyDebtPayment"
            label={t('Debt.CreditCard.MonthlyDebtPayment.label')}
            data-testid="debt-credit-card-monthly-debt-payment-input"
            format={formatSpacedNumber}
            suffix={t('suffix.currency')}
            {...debtCreditCardMonthlyDebtPaymentFieldOption}
          />
        )}
      </Grid>

      {/* TODO: Fix Style Its jumping due to Two Lines Label and two lines error message */}
      <Grid columns={gridColumns} className={styles.itemsEnd}>
        <NumberFieldUI<RefinanceDebtFormGroupData>
          name="Debt/Personal/OutstandingAmount"
          label={t('Debt.Personal.OutstandingAmount.label', {
            context: maritalStatus,
          })}
          data-testid="debt-personal-outstanding-amount-input"
          format={formatSpacedNumber}
          suffix={t('suffix.currency')}
          {...debtPersonalOutstandingAmountFieldOption}
        />

        {askPersonalDebtMonthlyPayment && (
          <NumberFieldUI<RefinanceDebtFormGroupData>
            name="Debt/Personal/MonthlyDebtPayment"
            label={t('Debt.Personal.MonthlyDebtPayment.label')}
            data-testid="debt-personal-monthly-debt-payment-input"
            format={formatSpacedNumber}
            suffix={t('suffix.currency')}
            {...debtPersonalMonthlyDebtPaymentFieldOption}
          />
        )}
      </Grid>
    </>
  );
};
